// extracted by mini-css-extract-plugin
export var actionText = "_hh-4";
export var container = "_hh-0";
export var leftSection = "_hh-1";
export var rightSection = "_hh-2";
export var settingsButton = "_hh-6";
export var settingsIcon = "_hh-7";
export var shortcut = "_hh-5";
export var shortcutGroup = "_hh-3";